module.exports = __webpack_public_path__ + "static/profil-034_optimized-9f2ba06454fa1c30dbc39866457e46a6.jpg";